import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { LoadingProps } from './Loading.types'

const Loading = ({ fontSize }: LoadingProps) => {
  return <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: fontSize || 24, color: '#E562DD' }} spin />} />
}

export default Loading
